<template>
  <v-col class="register default-slot" md="7" sm="12">
    <add-sire-modal
      :changeSireInfo="changeSireInfo"
      :sireDialog="sireDialog"
      :toggleSireModal="toggleSireModal"
      :sireInfo="sireInfo"
      :changePuppyInfo="changePuppyInfo"
    />
    <div class="top-icons">
      <a class="back-icon" v-on:click="changePage(1)">
        <font-awesome-icon icon="long-arrow-alt-left" size="lg" /> Back
      </a>
    </div>
    <h1>Litter Registration Application</h1>
    <p>Add sires & puppies to litter</p>
    <v-alert
      class="mb-2 mt-1"
      v-if="this.sireInfo.length && this.sireInfo.some(s => !s.dnaStatus) && this.sireInfo.some(s => !s.dnaSubmitted)"
      type='warning'
      >      
        <span v-html="sireDnaVerifiedWarning"></span>&nbsp;
        <span v-html="geneticTestingLink"></span>
    </v-alert>
    <v-row class="mt-3 mb-3" justify="center">
      <a v-on:click="toggleSireModal()">
        <font-awesome-icon
          :icon="this.sireInfo.length ? 'pencil-alt' : 'plus'"
        />
        {{ this.sireInfo.length ? "Add or Edit" : "Add" }} sire(s)
      </a>
    </v-row>
    <v-row v-for="sire in sireInfo" :key="sire.dogId" class="mb-2">
      <puppy-table
        :dam="damInfo"
        :sire="sire"
        :puppyInfo="puppies[sire.dogId]"
        :changePuppyInfo="changePuppyInfo"
        :mainColorChoices="colors.mainColors"
      />
    </v-row>
    <div>
      <v-btn
        class="white--text"
        large
        v-on:click="changePage(3)"
        :disabled="!isValid"
        color="primary"
        >NEXT</v-btn
      >
      <p class="steps">STEP <b>2</b> OF <b>3</b></p>
      <footer-text />
    </div>
  </v-col>
</template>

<script lang="ts">
import Vue from "vue";
import FooterText from "@/components/common/FooterText.vue";
import AddSireModal from "@/components/Portal/AddSireModal.vue";
import PuppyTable from "@/components/Portal/PuppyTable.vue";
import { LitterRegistration } from "@/constants";

export default Vue.extend({
  name: "RegisterLitterForm2",
  components: {
    AddSireModal,
    PuppyTable,
    FooterText,
  },
  data: function () {
    return {
      sireDialog: false,
      sireDnaVerifiedWarning: LitterRegistration.MissingDNA_Sire,    
      geneticTestingLink: LitterRegistration.GeneticTesting_Link,
    };
  },
  methods: {
    toggleSireModal: function () {
      this.$data.sireDialog = !this.$data.sireDialog;
    },
  },
  props: {
    changePage: Function,
    changeSireInfo: Function,
    changePuppyInfo: Function,
    damInfo: Object,
    sireInfo: Array,
    puppies: Object,
    colors: Object,
  },
  computed: {
    isValid: function () {
      return Object.values(this.puppies).reduce(
        (acc: any[], val: any) => acc.concat(val),
        []
      ).length;
    },
  },
});
</script>